import {
    ModalState,
} from '../../common/types/reducers';

export const modalInit: ModalState = {
    isVisible: false,
    isVisible2: false,
    header: {title: '', closeBtn: false},
    header2: {title: '', closeBtn: false},
    content: {type: null, data: null},
    content2: {type: null, data: null},
    footer: {cancelBtn: '', onPressCancelBtn: null, acceptBtn: '',
        onPressAcceptBtn: null, align: null, retryAction: null
    },
    footer2: {cancelBtn: '', onPressCancelBtn: null, acceptBtn: '',
        onPressAcceptBtn: null, align: null, retryAction: null
    },
    options: {closeOnOverlayClick: true, size: '', openSecondModal: false},
    options2: {closeOnOverlayClick: true, size: '', openSecondModal: true}
};